import { __decorate } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { getRtsp, getRtspMsg, getVideoSourceTree, getConfig, getSeiRtsp } from '@blade-sxp/monitor-center/api/index';
import lang from '@blade-sxp/monitor-center/lang/index';
import { setTaskMsg } from '@blade-sxp/monitor-center/config/setTaskMsg';
import { returnIncidentType } from '@blade-sxp/monitor-center/config/setIncidentType';
import { debounce } from 'lodash';
import ControlModule from '@blade-sxp/monitor-center/store/index';
let default_1 = class default_1 extends Vue {
    selectedDeviced;
    selectedDevicedArr;
    dragDevicedId;
    dragDevicedName;
    dragDevicedType;
    isDragStyle;
    singleScreenIndex; // 选中的屏幕: number;
    data = []; // tree 数据
    option = {
        normal: {
            fillStyle: '#0077FA',
            globalAlpha: 0.3,
            lineWidth: 2,
            strokeStyle: '#3295FB',
        },
    };
    polygonData = [];
    filterText = ''; // 关键字过滤
    defaultProps = {
        children: 'children',
        lable: 'lable',
    };
    get getselectedDeviced() {
        return ControlModule.selectedDeviced;
    }
    handleNodeClickDebounce = debounce((data) => {
        this.handleNodeClick(data);
    }, 100);
    // 初始化
    mounted() {
        this.getDevicedTree();
    }
    // 根据设备id获取视频流
    handleView(data) {
        // data.treeId=data.treeId
        this.getRtsp(data);
    }
    getRtsp(data) {
        getRtsp(String(data.id)).then((res1) => {
            getRtspMsg([data.id]).then(async (res) => {
                // 加一部分任务
                let taskMsgArr = [];
                const noLayer = {
                    name: `${this.$t('noLayer')}`,
                    id: 0,
                };
                res[data.id]?.forEach((item) => {
                    let incidentType = returnIncidentType(item.taskType);
                    this.$set(item, 'incidentType', incidentType);
                    taskMsgArr.push(item);
                });
                taskMsgArr.unshift(noLayer);
                const videoStreamObjTaskMsg = setTaskMsg(taskMsgArr);
                let videoStreamObj = {
                    title: data.parentName ? `${data.parentName}/${data.name}` : data.name,
                    rtsp: res1.rtspPreviewAddress,
                    id: data.id,
                    taskMsg: videoStreamObjTaskMsg,
                    taskId: '',
                    extendData: {},
                    polygonData: [],
                    keyId: this.genID(1),
                    setting: {},
                };
                await this.getFaceConfigData(String(data.id), videoStreamObj, taskMsgArr);
                if (!this.selectedDeviced?.includes(data.id)) {
                    let firstInd = this.selectedDevicedArr.findIndex((item) => !item.rtsp);
                    this.selectedDeviced?.splice(firstInd, 1, data.id);
                    let ind = this.selectedDeviced?.findIndex((item) => item === data.id);
                    this.selectedDevicedArr.splice(Number(ind), 1, videoStreamObj);
                    this.$emit('update:singleScreenIndex', ind);
                }
            });
        });
    }
    getFaceConfigData(id, videoStreamObj, taskMsgArr) {
        const videoStreamObjTaskMsg = setTaskMsg(taskMsgArr);
        const objTaskMsg = videoStreamObjTaskMsg.filter((item) => {
            return item.taskType === 'FACE_ALERT';
        });
        if (!objTaskMsg.length)
            return;
        const polygonData = objTaskMsg[0];
        const operateIds = [id];
        return new Promise((resolve) => {
            getConfig({ operateIds }).then((config) => {
                getSeiRtsp(id, String(polygonData.id)).then((video) => {
                    videoStreamObj.rtsp = video.rtspPreviewAddress;
                    let drawRect = true;
                    let drawAttributes = true;
                    if (config.length) {
                        const settingObj = config[0];
                        videoStreamObj.setting = settingObj;
                        drawRect = settingObj?.status === 'ENABLE';
                        drawAttributes = settingObj?.propertyDisplay === 'ENABLE';
                    }
                    resolve('');
                });
            });
        });
    }
    // 生成唯一ID
    genID(length) {
        return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36);
    }
    // 判断非空
    clearNull(arr) {
        return arr.filter((item) => item);
    }
    handleNodeClick(data) {
        // console.log('data', data);
        // 逻辑： 点击播放 四个就要移除才能再点击 或者拖拽替换
        if (this.selectedDeviced && this.selectedDeviced.includes(data.id)) {
            let ind = this.selectedDeviced?.findIndex((item) => item === data.id);
            this.$emit('update:singleScreenIndex', ind);
            return;
        }
        if (data.nodeType === 'DEVICE_GROUP') {
            return false;
        }
        if (this.selectedDeviced && this.clearNull(this.selectedDeviced).length >= 4) {
            return this.$message({
                message: this.$t('warnMessage'),
                type: 'warning',
            });
        }
        this.handleView(data);
    }
    filterTextChange(val) {
        this.$refs.tree.filter(val);
    }
    // 关键字过滤
    filterNode(value, data, node) {
        let parentNode = node.parent; // 父级node
        let labels = [node.data.name]; // 当前node的名字
        let level = 1; // 层级
        while (level < node.level) {
            labels = [...labels, parentNode.data.name]; // 当前node名字，父级node的名字
            parentNode = parentNode.parent;
            level++;
        }
        return labels.some((d) => d.indexOf(value) !== -1);
    }
    async getDevicedTree() {
        this.data = [];
        await getVideoSourceTree().then((res) => {
            this.data = res.trees;
            this.filterArr(this.data);
        });
    }
    filterArr(node) {
        node.forEach((item) => {
            if (item.children.length > 0) {
                this.filterArr(item.children);
                item.children.forEach((itemNode) => {
                    itemNode.parentName = item.name;
                });
            }
        });
    }
    dragstart(e, node) {
        this.$emit('update:dragDevicedId', node.data.id);
        this.$emit('update:dragDevicedName', node.data.name);
        this.$emit('update:dragDevicedType', node.data.nodeType);
    }
    drag(e) {
        // 拖拽中
    }
    dragend(e) {
        // 拖拽结束
        this.$emit('update:isDragStyle', false);
    }
};
__decorate([
    Prop()
], default_1.prototype, "selectedDeviced", void 0);
__decorate([
    Prop()
], default_1.prototype, "selectedDevicedArr", void 0);
__decorate([
    Prop()
], default_1.prototype, "dragDevicedId", void 0);
__decorate([
    Prop()
], default_1.prototype, "dragDevicedName", void 0);
__decorate([
    Prop()
], default_1.prototype, "dragDevicedType", void 0);
__decorate([
    Prop()
], default_1.prototype, "isDragStyle", void 0);
__decorate([
    Prop()
], default_1.prototype, "singleScreenIndex", void 0);
__decorate([
    Watch('filterText')
], default_1.prototype, "filterTextChange", null);
default_1 = __decorate([
    Component({
        name: 'leftTree',
        components: {},
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
